import React, { useEffect, useState } from 'react';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../../context/AuthContext';
import EssaysHubView from './EssaysHubView';
import { DeskEmpty } from './essayShared';

// The student's essays hub, opened by a parent or an advisor. Same list, same
// grouping, same flags — read through their grant, so an essay they may not
// see never arrives in the first place.
export default function SharedEssaysPage() {
  const { grantId } = useParams();
  const navigate = useNavigate();
  const { api } = useAuth();
  const { grant } = useOutletContext();

  const [essays, setEssays] = useState([]);
  const [owner, setOwner] = useState(null);
  const [loading, setLoading] = useState(true);
  const [denied, setDenied] = useState(null);

  useEffect(() => {
    let alive = true;
    api
      .get(`/college-access/shared/${grantId}/essays`)
      .then((res) => {
        if (!alive) return;
        setEssays(res.data.essays || []);
        setOwner(res.data.owner || null);
      })
      .catch((err) => {
        if (!alive) return;
        if (err.response?.status === 403) setDenied(err.response.data.error);
        else toast.error(err.response?.data?.error || 'Failed to load those essays');
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, [api, grantId]);

  if (loading) {
    return (
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '44px 32px 64px' }}>
        <p className="font-mono-editorial" style={{ fontSize: 13, color: 'var(--college-muted)' }}>
          Loading essays…
        </p>
      </div>
    );
  }

  if (denied) {
    return (
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '44px 32px 64px' }}>
        <DeskEmpty
          title="Not shared with you"
          body={`${denied}. ${grant.ownerName} decides what comes through here, and can turn this on at any time.`}
        />
      </div>
    );
  }

  return (
    <EssaysHubView
      essays={essays}
      viewer={{ kind: 'grant', id: grant.id, name: grant.name, role: grant.role }}
      owner={owner}
      onOpen={(id) => navigate(`/shared/${grantId}/essays/${id}`)}
      eyebrowSuffix={`${grant.ownerName}'s essays`}
    />
  );
}
